// extracted by mini-css-extract-plugin
export default {"home":"KpnHome_home__kD9uG","topImageContainer":"KpnHome_topImageContainer__4LEJv","overlayHeader":"KpnHome_overlayHeader__spw+k","overlayRevision":"KpnHome_overlayRevision__uT+4d"};